<template>
    <img
        v-if="type === 1 && !layout.position"
        class="card-img-top"
        :src="image(layout.upload, 'thumb')"
    />
    <div
        v-else-if="type === 1"
        class="nch--card-thumb d-flex align-items-center justify-content-center"
    >
        <img
            :src="image(layout && layout.upload, 'thumb')"
            style="max-width: 100%; height: auto; max-height: 280px;"
        />
    </div>
    <div
        v-else-if="type === 2"
        id="nch--showcase-video-container"
        class="iframe__box"
        v-html="layout && layout.source"
    ></div>
</template>

<script>
import image from '../../mixins/image';

export default {
    mixins: [
        image,
    ],
    props: {
        plan: {
            type: Object,
        },
        content: {
            type: Object,
        },
    },
    computed: {
        layout() {
            return this.plan && this.plan.layout;
        },
        type() {
            return this.layout && this.layout.type;
        },
    },
};
</script>
